import { CanalCobrancaEnum } from '../../../enums/financas/canal-cobranca.enum';
import { ReturnStruct } from '../../structs/return.struct';

export class GerarCobrancaResponse extends ReturnStruct {
    emailEnviado: string | null = null;

    // Resultado da geração (feedback do modal). Boleto traz os artefatos; PIX só confirma o canal + e-mail.
    canal: CanalCobrancaEnum = CanalCobrancaEnum.Generico;
    jaPago: boolean = false;
    linhaDigitavel: string | null = null;
    codigoBarras: string | null = null;
    urlBoletoPdf: string | null = null;
}
